import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import closeIcon from "assets/images/icons/btn_close.png";
import ButtonBase, { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import clsx from "clsx";

const useStyles = (width: number) =>
    makeStyles((theme: Theme) => {
        return createStyles({
            root: {
                borderRadius: "50%",
                maxWidth: width,
                transition: "transform 0.05s ease-in-out",
                "&:hover": {
                    transform: "rotate(15deg)",
                },
                "& img": { width: "100%" },
            },
            disabled: {
                "& img": {
                    filter: "grayscale(100%)",
                },
            },
        });
    });

interface IProps extends ButtonBaseProps {
    width?: number;
}

export default function DialogCloseButton(props: IProps) {
    const { className, disabled = false, width = 50, ...rest } = props;
    const classes = useStyles(width)();

    return (
        <ButtonBase
            className={clsx(className, classes.root, { [classes.disabled]: disabled })}
            disabled={disabled}
            {...rest}
        >
            <img src={closeIcon} alt="Close Dialog" />
        </ButtonBase>
    );
}
